import { Utils } from "@/utilities/Utils";

export class VoucherCodeSaveRequest {
    allocationID: number = 0;
    voucherCodeAmount: number = 0;
}